"use strict";

var _themeSections = require("@shopify/theme-sections");

var _carousel = _interopRequireDefault(require("../components/carousel"));

var _quickView = _interopRequireDefault(require("../components/quick-view"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Featured collection
 * ------------------------------------------------------------------------------
 * Configured section to display a single collection in product cards
 * - includes enable slider option
 *
 * @namespace featuredCollection
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-featured-collection="carousel"]',
  cell: '[js-featured-collection="slide"]'
};
/**
 * Register a single featured collection section.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('featured-collection', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var container = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.container);
    var cells = "[data-section-id=\"".concat(this.id, "\"] ").concat(selectors.cell);
    this.cache = {
      container: container,
      cells: cells
    };
  },

  /**
   * Check if the section has enabled the slider option.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Check if mobile screen.
   */
  checkForTouchScreen: function checkForTouchScreen() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel: function constructCarousel() {
    if (this.checkForTouchScreen() === 0) {
      (0, _carousel["default"])(this.cache.container, {
        cellSelector: this.cache.cells,
        cellAlign: 'left',
        prevNextButtons: true,
        friction: 0.2
      }).init();
    } else {
      (0, _carousel["default"])(this.cache.container, {
        cellSelector: this.cache.cells,
        cellAlign: 'left',
        prevNextButtons: true,
        freeScroll: true,
        freeScrollFriction: 0.1
      }).init();
    }
  },

  /**
   * Construct new carousel on `section:load`.
   */
  onLoad: function onLoad() {
    (0, _quickView["default"])().init();
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  }
});